$(document).ready(function(){

    $("#contactForm").validate({
                                   rules: {
                                       name: "required",
                                       email: {
                                           required: true,
                                           email: true
                                       },
                                       user_message: "required",
                                       captcha: "required"
                                   },
                                   messages: {
                                       name: "Required",
                                       email: {
                                           email: "name@domain.com",
                                           required: "Required"
                                       },
                                       user_message: "Required",
                                       captcha: "Required"
                                   }
                               });

    $("#shippingOptions").validate({
                                       rules: {
                                           shipping_option: "required"
                                       },
                                       messages: {
                                           shipping_option: "Please select an option."
                                       },
                                       errorPlacement: function(error, element){
                                           $('.validationErrorContainer').html('<div class="validationError">'+error.html()+'</div>');
                                       }
                                   });

});

$(document).ready(function(){

    $("a[rel^='prettyPhoto']").prettyPhoto({
                                               overlay_gallery: false,
                                               social_tools: false,
                                               slideshow: false,
                                               allow_resize: true,
                                               deeplinking: false,
                                           });

    $("a[rel^='external']").on('click', function(e){
        e.preventDefault();
        window.open(this.href);
    });

    /*
    * submit a form on select option change
    */
    $('.submitOnChange').on('change', function(){
        form = $(this).closest("form");
        form.submit();
    });
        
    $('.gotoOnChange').on('change', function(){
        url = $(this).val();
        window.location.href = url;
    });
    
    /*
    * disable links
    */
    $(".disabled").on('click', function(e){
        e.preventDefault();
    });

});

